<div class="form-row m-0">
  <mat-form-field appearance="outline" class="coordinates w-100">
    <input matInput [value]="inputLabel" #searchTextField type="text" [disabled]="disabled"
      placeholder="Insert geographic coordinates (N. XX.XXXX, E. YY.YYYY)" (input)="onChangeContent($event)"
      (keyup.enter)="checkCoordinates()" />
    <button *ngIf="!showSearchIcon && inputLabel" mat-button matSuffix mat-icon-button class="ml-2"
      (click)="reset()">
      <i class="fas fa-times blue"></i>
    </button>
    <button *ngIf="showSearchIcon || !inputLabel" mat-button matSuffix mat-icon-button class="ml-2"
      (click)="checkCoordinates()">
      <i class="fas fa-search blue"></i>
    </button>
  </mat-form-field>
</div>
